(function () {
  'use strict'
  if (window.Shopify && window.Shopify.designMode) return
  if (window.__CHICCHOK_GMC_EVIDENCE_V1__) return
  window.__CHICCHOK_GMC_EVIDENCE_V1__ = true

  var storageKey = 'chicchok_gmc_evidence_v1'
  var cleanupKey = 'chicchok_gmc_clear_pending_v1'
  var lifetime = 30 * 24 * 60 * 60 * 1000
  var ownedKeys = ['evidence_version', 'evidence_type', 'click_sha256', 'campaign', 'landing_path', 'variant_id', 'first_touch_at', 'last_touch_at', 'expires_at', 'cart_binding', 'paid_conflict']
  var enabled = false
  var epoch = 0
  var memory = null
  var memoryOnly = false
  var queue = Promise.resolve()
  var timer = null
  var refreshTimer = null
  var expiryTimer = null
  var failures = 0
  var checks = 0
  var lastCheck = 0
  var captureStarted = false
  var cleanupPending = false
  var permissionReady = false
  var featureRequested = false
  // The approved five-product pilot is an enrollment allowlist, not a site-wide rollout.
  var v2 = createV2Pilot()

  function createV2Pilot() {
    var key = 'chicchok_gmc_evidence_v2'
    var clearKey = 'chicchok_gmc_v2_clear_pending'
    var slots = ['first_feed_touch', 'last_feed_touch', 'last_google_touch', 'checkout_context']
    var idle = 30 * 60 * 1000
    var chunkSize = 180
    var chunkLimit = 6
    var local = null
    var localOnly = false
    var pending = false
    var navigationUsed = false
    var lastActivityPersisted = 0
    var products = [
      { id: '9102301823283', paths: ['/de/products/chicchok-breathless', '/fr/products/chicchok-breathless', '/id/products/chicchok-breathless', '/it/products/chicchok-breathless', '/ja/products/chicchok-breathless', '/ko/products/chicchok-breathless', '/products/chicchok-breathless'], feedPath: '/products/chicchok-breathless', ds: '10709817526', pairs: [
        ['48682212950323', 'shopify_US_9102301823283_48682212950323'], ['48682212983091', 'shopify_US_9102301823283_48682212983091'], ['48682213015859', 'shopify_US_9102301823283_48682213015859'], ['48682213048627', 'shopify_US_9102301823283_48682213048627'],
        ['49507159081267', 'shopify_US_9102301823283_49507159081267'], ['49507159114035', 'shopify_US_9102301823283_49507159114035'], ['49507234152755', 'shopify_US_9102301823283_49507234152755'], ['49507234185523', 'shopify_US_9102301823283_49507234185523'], ['49507234218291', 'shopify_US_9102301823283_49507234218291'],
        ['49507602006323', 'shopify_US_9102301823283_49507602006323'], ['49507602039091', 'shopify_US_9102301823283_49507602039091'], ['49507602071859', 'shopify_US_9102301823283_49507602071859'], ['49507602104627', 'shopify_US_9102301823283_49507602104627'], ['49507602137395', 'shopify_US_9102301823283_49507602137395'], ['49507602170163', 'shopify_US_9102301823283_49507602170163'], ['49507602202931', 'shopify_US_9102301823283_49507602202931'], ['49507602235699', 'shopify_US_9102301823283_49507602235699'], ['49507602268467', 'shopify_US_9102301823283_49507602268467'], ['49507602301235', 'shopify_US_9102301823283_49507602301235'], ['49507602334003', 'shopify_US_9102301823283_49507602334003'], ['49507602366771', 'shopify_US_9102301823283_49507602366771'], ['49507602399539', 'shopify_US_9102301823283_49507602399539'], ['49507602432307', 'shopify_US_9102301823283_49507602432307'], ['49507602465075', 'shopify_US_9102301823283_49507602465075'], ['49507602497843', 'shopify_US_9102301823283_49507602497843'], ['49507602530611', 'shopify_US_9102301823283_49507602530611'], ['49507602563379', 'shopify_US_9102301823283_49507602563379'],
        ['49507691397427', 'shopify_US_9102301823283_49507691397427'], ['49507691430195', 'shopify_US_9102301823283_49507691430195'], ['49507691462963', 'shopify_US_9102301823283_49507691462963'], ['49507691495731', 'shopify_US_9102301823283_49507691495731'], ['49507691528499', 'shopify_US_9102301823283_49507691528499'], ['49507691561267', 'shopify_US_9102301823283_49507691561267'], ['49507691594035', 'shopify_US_9102301823283_49507691594035'], ['49507691626803', 'shopify_US_9102301823283_49507691626803'], ['49507691659571', 'shopify_US_9102301823283_49507691659571'],
        ['52586513432883', 'shopify_US_9102301823283_52586513432883'], ['52586513465651', 'shopify_US_9102301823283_52586513465651'], ['52586513498419', 'shopify_US_9102301823283_52586513498419'], ['52586513531187', 'shopify_US_9102301823283_52586513531187'], ['52586513563955', 'shopify_US_9102301823283_52586513563955'], ['52586513596723', 'shopify_US_9102301823283_52586513596723'], ['52586513629491', 'shopify_US_9102301823283_52586513629491'], ['52586513662259', 'shopify_US_9102301823283_52586513662259'], ['52586513695027', 'shopify_US_9102301823283_52586513695027']
      ] },
      { id: '9778744492339', paths: ['/products/heart-o-ring-slip-chain-necklace-punk-rock-stainless-steel-cuban-y-necklace'], feedPath: '/products/heart-o-ring-slip-chain-necklace-punk-rock-stainless-steel-cuban-y-necklace', ds: '10709817526', pairs: [
        ['51690098622771', 'shopify_US_9778744492339_51690098622771'], ['51690098655539', 'shopify_US_9778744492339_51690098655539'], ['51690098688307', 'shopify_US_9778744492339_51690098688307'], ['51690098721075', 'shopify_US_9778744492339_51690098721075'], ['51690098753843', 'shopify_US_9778744492339_51690098753843'], ['51690098786611', 'shopify_US_9778744492339_51690098786611']
      ] },
      { id: '9778814845235', paths: ['/products/chicchok-handmade-o-ring-lariat-choker-necklace-for-women-adjustable-multicolor-chain'], feedPath: '/products/chicchok-handmade-o-ring-lariat-choker-necklace-for-women-adjustable-multicolor-chain', ds: '10709817526', pairs: [
        ['51690473324851', 'shopify_US_9778814845235_51690473324851'], ['51690473357619', 'shopify_US_9778814845235_51690473357619'], ['51690473390387', 'shopify_US_9778814845235_51690473390387'], ['51690473423155', 'shopify_US_9778814845235_51690473423155'], ['51690473455923', 'shopify_US_9778814845235_51690473455923'], ['51690473488691', 'shopify_US_9778814845235_51690473488691']
      ] },
      { id: '10037302460723', paths: ['/es/products/suffocation-and-redemption', '/products/suffocation-and-redemption'], feedPath: '/products/suffocation-and-redemption', ds: '10709817526', pairs: [
        ['52877616939315', 'shopify_US_10037302460723_52877616939315'], ['53807857959219', 'shopify_US_10037302460723_53807857959219']
      ] },
      { id: '10191060369715', paths: ['/products/chicchok-bloodbound-stigmata-leather-choker-gothic-translucent-red-heart-collar-heavy-punk-cyber-techwear-fringe-jewelry'], feedPath: '/products/chicchok-bloodbound-stigmata-leather-choker-gothic-translucent-red-heart-collar-heavy-punk-cyber-techwear-fringe-jewelry', ds: '10709817526', pairs: [['53404938404147', 'shopify_US_10191060369715_53404938404147']] }
    ]

    function iso(value) { return new Date(value).toISOString() }
    function date(value) {
      if (typeof value !== 'string' || value.length !== 24) return NaN
      var n = Date.parse(value)
      return Number.isFinite(n) && iso(n) === value ? n : NaN
    }
    function randomId() {
      if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') return ''
      return Array.from(window.crypto.getRandomValues(new Uint8Array(8))).map(function (b) { return b.toString(16).padStart(2, '0') }).join('')
    }
    function hex(value) { return typeof value === 'string' && /^[a-f0-9]{16}$/.test(value) }
    function shape(value, names) {
      return Boolean(value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === names.length && names.every(function (name) { return Object.prototype.hasOwnProperty.call(value, name) }))
    }
    function safePath(value) {
      return typeof value === 'string' && value.length <= 200 && /^[\x20-\x7e]*$/.test(value) && (!value || /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages|blogs|policies)(?:\/[A-Za-z0-9._~%/-]*)?|cart|search)?$/i.test(value)) && !/[?#\\\s<>@:]/.test(value) && !/%(?:2f|5c|3f|23|40|3a)/i.test(value) && !/\/{2}/.test(value) && !/(?:^|\/)(?:\.|%2e){1,2}(?:\/|$)/i.test(value)
    }
    function productById(id) { return products.find(function (p) { return p.id === id }) }
    function observedProduct(path, variant) {
      var product = products.find(function (p) { return p.paths.indexOf(path) >= 0 })
      if (!product) return null
      if (variant && (!/^\d{1,24}$/.test(variant) || !product.pairs.some(function (pair) { return pair[0] === variant }))) return null
      return product
    }
    function feedPair(product, path, variant) {
      if (!product || !variant || path !== product.feedPath) return null
      return product.pairs.find(function (pair) { return pair[0] === variant }) || null
    }
    function cohortValid(cohort, now) {
      if (!shape(cohort, ['id', 'pid', 'at', 'exp']) || !hex(cohort.id) || !productById(cohort.pid)) return false
      var start = date(cohort.at), end = date(cohort.exp)
      return Number.isFinite(start) && Number.isFinite(end) && start <= now + 60000 && start < end && end - start === lifetime && end > now
    }
    function touchValid(touch, cohort, now) {
      if (!shape(touch, ['id', 'at', 'exp', 'kind', 'src', 'med', 'camp', 'ref', 'path', 'pid', 'var', 'offer', 'ds', 'native', 'click', 'paid']) || !hex(touch.id)) return false
      var at = date(touch.at), exp = date(touch.exp)
      if (!Number.isFinite(at) || !Number.isFinite(exp) || exp - at !== lifetime || at < date(cohort.at) || at >= date(cohort.exp) || at > now + 60000) return false
      if (['feed', 'google', 'paid', 'other', 'unknown'].indexOf(touch.kind) < 0 || ['google', 'other', 'unknown'].indexOf(touch.src) < 0 || ['product_sync', 'organic', 'paid', ''].indexOf(touch.med) < 0 || ['sag_organic', ''].indexOf(touch.camp) < 0 || ['google', 'external', 'same', 'none'].indexOf(touch.ref) < 0) return false
      if (!safePath(touch.path) || typeof touch.pid !== 'string' || typeof touch.var !== 'string' || typeof touch.offer !== 'string' || typeof touch.ds !== 'string' || typeof touch.native !== 'boolean' || typeof touch.paid !== 'boolean') return false
      if (typeof touch.click !== 'string' || (touch.native ? !/^[a-f0-9]{64}$/.test(touch.click) : touch.click !== '')) return false
      if (touch.pid) {
        var product = observedProduct(touch.path, touch.var)
        if (!product || product.id !== touch.pid) return false
      } else if (touch.var || touch.offer || touch.ds) return false
      if (touch.kind === 'feed') {
        var pair = feedPair(productById(touch.pid), touch.path, touch.var)
        if (!pair || pair[1] !== touch.offer || productById(touch.pid).ds !== touch.ds || touch.src !== 'google' || touch.ref !== 'google' || touch.med !== 'product_sync' || touch.camp !== 'sag_organic' || touch.paid) return false
      } else if (touch.offer || touch.ds) return false
      if (touch.paid !== (touch.kind === 'paid')) return false
      return true
    }
    function raw() {
      if (localOnly) return local
      try { return JSON.parse(window.localStorage.getItem(key) || 'null') } catch (error) { return local }
    }
    function persist(state) {
      local = state
      try {
        if (state) window.localStorage.setItem(key, JSON.stringify(state))
        else window.localStorage.removeItem(key)
        localOnly = false
      } catch (error) { localOnly = true }
    }
    function markPending(value) {
      pending = value
      try {
        if (value) window.localStorage.setItem(clearKey, '1')
        else window.localStorage.removeItem(clearKey)
      } catch (error) {}
    }
    function remove() {
      if (local || raw() || pending) {
        persist(null)
        markPending(true)
        schedule(0)
      }
    }
    function state() {
      var value = raw(), now = Date.now()
      if (!value) return null
      if (!shape(value, ['v', 'cohort', 'first_feed_touch', 'last_feed_touch', 'last_google_touch', 'context', 'synced']) || value.v !== 2 || !cohortValid(value.cohort, now) || !shape(value.context, ['id', 'at', 'last', 'entry', 'paidAfterFeed']) || !hex(value.context.id) || typeof value.context.paidAfterFeed !== 'boolean' || typeof value.synced !== 'string' || (value.synced && !/^[a-f0-9]{64}$/.test(value.synced))) { remove(); return null }
      var contextAt = date(value.context.at), contextLast = date(value.context.last)
      if (!Number.isFinite(contextAt) || !Number.isFinite(contextLast) || contextAt < date(value.cohort.at) || contextLast < contextAt || contextLast > now + 60000 || contextLast >= date(value.cohort.exp)) { remove(); return null }
      var touches = [value.first_feed_touch, value.last_feed_touch, value.last_google_touch, value.context.entry]
      if (touches.some(function (t) { return t !== null && !touchValid(t, value.cohort, now) })) { remove(); return null }
      if (value.context.entry && (date(value.context.entry.at) < contextAt || date(value.context.entry.at) > contextLast)) { remove(); return null }
      if (value.first_feed_touch && value.first_feed_touch.kind !== 'feed' || value.last_feed_touch && value.last_feed_touch.kind !== 'feed' || value.last_google_touch && value.last_google_touch.src !== 'google') { remove(); return null }
      if (value.first_feed_touch && value.last_feed_touch && date(value.first_feed_touch.at) > date(value.last_feed_touch.at)) { remove(); return null }
      if (value.first_feed_touch && !value.last_feed_touch) { remove(); return null }
      var changed = false
      ;['first_feed_touch', 'last_feed_touch', 'last_google_touch'].forEach(function (slot) {
        if (value[slot] && date(value[slot].exp) <= now) { value[slot] = null; changed = true }
      })
      if (value.context.entry && date(value.context.entry.exp) <= now) { value.context.entry = null; changed = true }
      if (changed) { value.synced = ''; persist(value) }
      return value
    }
    function reference() {
      if (!document.referrer) return { kind: 'none', external: false }
      try {
        var url = new URL(document.referrer)
        if (url.protocol !== 'https:' && url.protocol !== 'http:') return { kind: 'none', external: false }
        var host = url.hostname.toLowerCase()
        if (host === 'chicchok.com' || host.endsWith('.chicchok.com') || host === 'chic-chok-8921.myshopify.com' || host === window.location.hostname.toLowerCase()) return { kind: 'same', external: false }
        return { kind: /(^|\.)google\.(?:com|[a-z]{2}|com\.[a-z]{2}|co\.[a-z]{2})$/.test(host) ? 'google' : 'external', external: true }
      } catch (error) { return { kind: 'none', external: false } }
    }
    function newExternalNavigation(ref) {
      if (!ref.external) return false
      try {
        var navigation = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0]
        return Boolean(navigation && navigation.type === 'navigate')
      } catch (error) { return false }
    }
    function fingerprint(value) {
      return JSON.stringify([value.cohort, value.first_feed_touch, value.last_feed_touch, value.last_google_touch, value.context])
    }
    function activity(force) {
      if (!enabled || consent() !== true) return
      var value = state()
      if (!value) return
      var now = Date.now()
      if (!force && now - lastActivityPersisted < 30000) return
      if (now - date(value.context.last) >= idle) {
        var id = randomId()
        if (!id) return
        value.context = { id: id, at: iso(now), last: iso(now), entry: null, paidAfterFeed: value.context.paidAfterFeed }
      } else value.context.last = iso(now)
      value.synced = ''
      persist(value)
      lastActivityPersisted = now
    }
    function capture() {
      if (!enabled || consent() !== true || navigationUsed) return Promise.resolve()
      navigationUsed = true
      var value = state(), ref = reference(), external = newExternalNavigation(ref)
      var params = new URLSearchParams(window.location.search), rawVariant = params.get('variant') || ''
      var path = safePath(window.location.pathname) ? window.location.pathname : ''
      // An explicitly supplied empty, repeated, malformed or foreign variant cannot enroll.
      var variantOkay = !params.has('variant') || params.getAll('variant').length === 1 && /^\d{1,24}$/.test(rawVariant)
      var product = variantOkay && path ? observedProduct(path, rawVariant) : null
      if (!value && (!external || !product)) return Promise.resolve()
      if (!external) { activity(true); return Promise.resolve() }
      var now = Date.now(), startedEpoch = epoch
      var touchId = randomId()
      if (!touchId) return Promise.resolve()
      if (!value) {
        var cohortId = randomId(), contextId = randomId()
        if (!cohortId || !contextId) return Promise.resolve()
        value = { v: 2, cohort: { id: cohortId, pid: product.id, at: iso(now), exp: iso(now + lifetime) }, first_feed_touch: null, last_feed_touch: null, last_google_touch: null, context: { id: contextId, at: iso(now), last: iso(now), entry: null, paidAfterFeed: false }, synced: '' }
      }
      var rawClick = params.get('srsltid') || ''
      var native = params.getAll('srsltid').length === 1 && /^[A-Za-z0-9_-]{8,512}$/.test(rawClick)
      var paid = paidEntry(params) || Boolean(params.get('dclid')) || Boolean(params.get('msclkid'))
      var exactTags = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].every(function (name) { return params.getAll(name).length === 1 }) && params.get('utm_source') === 'google' && params.get('utm_medium') === 'product_sync' && params.get('utm_campaign') === 'sag_organic' && params.get('utm_content') === 'sag_organic'
      var observedMedium = params.getAll('utm_medium').length === 1 && ['product_sync', 'organic'].indexOf(params.get('utm_medium')) >= 0 ? params.get('utm_medium') : ''
      var observedCampaign = params.getAll('utm_campaign').length === 1 && params.get('utm_campaign') === 'sag_organic' ? 'sag_organic' : ''
      var pair = feedPair(product, path, rawVariant)
      var feed = Boolean(exactTags && pair && ref.kind === 'google' && !paid)
      return (native ? digest(rawClick) : Promise.resolve('')).then(function (click) {
        if (!enabled || consent() !== true || startedEpoch !== epoch || (native && !click)) return
        // Reload a current enrolled state if another tab changed it while hashing.
        var current = state()
        if (current) value = current
        if (!cohortValid(value.cohort, Date.now())) return
        var touch = { id: touchId, at: iso(now), exp: iso(now + lifetime), kind: paid ? 'paid' : feed ? 'feed' : ref.kind === 'google' ? 'google' : 'other', src: ref.kind === 'google' ? 'google' : 'other', med: paid ? 'paid' : observedMedium, camp: observedCampaign, ref: ref.kind, path: path, pid: product ? product.id : '', var: product && rawVariant ? rawVariant : '', offer: feed ? pair[1] : '', ds: feed ? product.ds : '', native: native, click: native ? click : '', paid: paid }
        if (!touchValid(touch, value.cohort, Date.now())) return
        var id = randomId()
        if (!id) return
        value.context = { id: id, at: iso(now), last: iso(now), entry: touch, paidAfterFeed: value.context.paidAfterFeed || Boolean(paid && value.last_feed_touch) }
        if (feed) { if (!value.first_feed_touch) value.first_feed_touch = touch; value.last_feed_touch = touch }
        if (touch.src === 'google') value.last_google_touch = touch
        value.synced = ''
        persist(value)
        lastActivityPersisted = now
        armCombinedExpiry()
        schedule(0)
      }).catch(function () { remove() })
    }
    function emptyAttributes() {
      var result = { __gmc_v2_version__: '', __gmc_v2_contract__: '', __gmc_v2_cart_binding__: '' }
      slots.forEach(function (slot) {
        result['__gmc_v2_' + slot + '_n__'] = ''
        result['__gmc_v2_' + slot + '_sha256__'] = ''
        for (var i = 0; i < chunkLimit; i += 1) result['__gmc_v2_' + slot + '_' + i + '__'] = ''
      })
      return result
    }
    function payload(binding) {
      var value = state()
      if (!value) return Promise.resolve(null)
      var context = { v: 2, cohort: value.cohort, id: value.context.id, at: value.context.at, last: value.context.last, entry: value.context.entry, paidAfterFeed: value.context.paidAfterFeed }
      var texts = [value.first_feed_touch, value.last_feed_touch, value.last_google_touch, context].map(function (item) { return item === null ? '' : JSON.stringify(item) })
      if (texts.some(function (text) { return text.length > chunkSize * chunkLimit || !/^[\x20-\x7e]*$/.test(text) })) { remove(); return Promise.resolve(null) }
      var mark = fingerprint(value)
      return Promise.all(texts.map(function (text) { return text ? digest(text) : Promise.resolve('') })).then(function (hashes) {
        if (hashes.some(function (hash, i) { return texts[i] && !/^[a-f0-9]{64}$/.test(hash) })) { remove(); return null }
        var output = emptyAttributes()
        output.__gmc_v2_version__ = '2'
        output.__gmc_v2_contract__ = 'touch-slots-1'
        output.__gmc_v2_cart_binding__ = binding
        slots.forEach(function (slot, index) {
          var text = texts[index], count = Math.ceil(text.length / chunkSize)
          output['__gmc_v2_' + slot + '_n__'] = String(count)
          output['__gmc_v2_' + slot + '_sha256__'] = hashes[index]
          for (var i = 0; i < count; i += 1) output['__gmc_v2_' + slot + '_' + i + '__'] = text.slice(i * chunkSize, (i + 1) * chunkSize)
        })
        return { attributes: output, fingerprint: mark, synced: value.synced }
      }).catch(function () { remove(); return null })
    }
    function relevant() { return Boolean(pending || state()) }
    function nextExpiry() {
      var value = state()
      if (!value) return NaN
      return Math.min.apply(Math, [date(value.cohort.exp)].concat([value.first_feed_touch, value.last_feed_touch, value.last_google_touch, value.context.entry].filter(Boolean).map(function (t) { return date(t.exp) })))
    }
    function synced(mark, hash) {
      var value = state()
      if (value && fingerprint(value) === mark && /^[a-f0-9]{64}$/.test(hash)) { value.synced = hash; persist(value) }
    }
    function onStorage(event) {
      if (event.key !== key && event.key !== clearKey) return
      try { pending = window.localStorage.getItem(clearKey) === '1' } catch (error) {}
      if (pending || enabled && consent() === true && state()) schedule()
    }
    try { pending = window.localStorage.getItem(clearKey) === '1' } catch (error) {}
    return { capture: capture, state: state, remove: remove, activity: activity, relevant: relevant, pending: function () { return pending }, empty: emptyAttributes, clean: function () { markPending(false) }, payload: payload, synced: synced, nextExpiry: nextExpiry, onStorage: onStorage, matches: function (mark) { var current = state(); return Boolean(current && fingerprint(current) === mark) } }
  }

  function stored() {
    if (memoryOnly) return memory
    try { return JSON.parse(window.localStorage.getItem(storageKey) || 'null') }
    catch (error) { return memory }
  }

  function save(value) {
    memory = value
    try {
      if (value) window.localStorage.setItem(storageKey, JSON.stringify(value))
      else window.localStorage.removeItem(storageKey)
      memoryOnly = false
    } catch (error) { memoryOnly = true }
  }

  function pendingCleanup(value) {
    cleanupPending = value
    try {
      if (value) window.localStorage.setItem(cleanupKey, '1')
      else window.localStorage.removeItem(cleanupKey)
    } catch (error) {}
  }

  function valid(value) {
    if (!value || value.version !== '1') return null
    var now = Date.now()
    var first = Date.parse(value.first)
    var last = Date.parse(value.last)
    var expires = Date.parse(value.expires)
    if (!Number.isFinite(first) || !Number.isFinite(last) || !Number.isFinite(expires)) return null
    if (first > now + 60000 || last < first || last > now + 60000 || expires <= now || expires - first !== lifetime || last >= expires) return null
    if (value.type !== 'native_srsltid' && value.type !== 'manual_feed_utm') return null
    if (value.type === 'native_srsltid' && !/^[a-f0-9]{64}$/.test(value.click || '')) return null
    if (value.click && !/^[a-f0-9]{64}$/.test(value.click)) return null
    if (!/^[a-f0-9]{64}$/.test(value.signature || '')) return null
    if (typeof value.path !== 'string' || value.path.length > 200 || (value.path && (!value.path.startsWith('/') || /[?#\\\s<>@]/.test(value.path)))) return null
    if (value.variant && !/^\d{1,24}$/.test(value.variant)) return null
    if (value.campaign && !/^(sag_organic|merchant_free_listings|gmc_free_listings|shopping free listings)$/.test(value.campaign)) return null
    if (value.paid !== '0' && value.paid !== '1') return null
    return value
  }

  function digest(value) {
    if (!window.crypto || !window.crypto.subtle || typeof TextEncoder !== 'function') return Promise.resolve('')
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buffer) {
      return Array.from(new Uint8Array(buffer)).map(function (byte) { return byte.toString(16).padStart(2, '0') }).join('')
    })
  }

  function consent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy
      if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.analyticsProcessingAllowed !== 'function') return null
      return privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true
    } catch (error) { return null }
  }

  function route(file) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'
    var url = new URL(root + file, window.location.origin)
    if (url.origin !== window.location.origin || !/\/cart\/(?:update\.js)$|\/cart\.js$/.test(url.pathname)) throw new Error('cart_route')
    return url.href
  }

  function request(file, attributes) {
    var controller = new AbortController()
    var deadline = window.setTimeout(function () { controller.abort() }, 1800)
    var options = { method: attributes ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal, keepalive: Boolean(attributes) }
    if (attributes) {
      options.headers = { 'Content-Type': 'application/json' }
      options.body = JSON.stringify({ attributes: attributes })
    }
    return window.fetch(route(file), options).then(function (response) {
      if (!response.ok) throw new Error('cart_request')
      return response.json()
    }).finally(function () { window.clearTimeout(deadline) })
  }

  function attributes(value, binding) {
    var values = {
      __gmc_evidence_version: '1', __gmc_evidence_type: value.type,
      __gmc_click_sha256: value.click, __gmc_campaign: value.campaign,
      __gmc_landing_path: value.path, __gmc_variant_id: value.variant,
      __gmc_first_touch_at: value.first, __gmc_last_touch_at: value.last,
      __gmc_expires_at: value.expires, __gmc_cart_binding: binding,
      __gmc_paid_conflict: value.paid
    }
    var result = {}
    Object.keys(values).forEach(function (key) { result[key + '__'] = values[key] })
    return result
  }

  function enqueue(work) {
    queue = queue.then(work, work).catch(function () {
      failures += 1
      if (failures <= 2) schedule(1200 * failures)
    })
  }

  function clearCart() {
    var empty = {}
    ownedKeys.forEach(function (key) { empty['__gmc_' + key + '__'] = '' })
    return request('cart/update.js', empty).then(function () {
      pendingCleanup(false)
      failures = 0
    })
  }

  function removeEvidence() {
    var hadEvidence = Boolean(memory || stored() || cleanupPending)
    save(null)
    window.clearTimeout(expiryTimer)
    if (hadEvidence) pendingCleanup(true)
    if (cleanupPending) schedule(0)
  }

  function expiry(value) {
    window.clearTimeout(expiryTimer)
    expiryTimer = window.setTimeout(function () {
      var current = valid(stored())
      if (current && enabled && consent() === true) expiry(current)
      else removeEvidence()
    }, Math.min(Math.max(Date.parse(value.expires) - Date.now(), 1), 2147483647))
  }

  function syncV1() {
    if (cleanupPending) {
      return clearCart().then(function () {
        if (enabled && consent() === true && valid(stored())) schedule(0)
      })
    }
    if (!enabled || consent() !== true || checks >= 40 || failures > 2) return Promise.resolve()
    if (Date.now() - lastCheck < 300) { schedule(310 - (Date.now() - lastCheck)); return Promise.resolve() }
    var value = valid(stored())
    if (!value) {
      if (memory || stored()) removeEvidence()
      return Promise.resolve()
    }
    var startedEpoch = epoch
    lastCheck = Date.now()
    checks += 1
    return request('cart.js').then(function (cart) {
      if (!enabled || consent() !== true || startedEpoch !== epoch) return
      var token = typeof cart.token === 'string' ? cart.token : ''
      if (!token || token.length > 2048) return
      return digest(token).then(function (binding) {
        if (!binding || !enabled || consent() !== true || startedEpoch !== epoch) return
        value = valid(stored())
        if (!value) return removeEvidence()
        var payload = attributes(value, binding)
        var signature = JSON.stringify(payload)
        if (value.synced === signature) return
        if (!enabled || consent() !== true || startedEpoch !== epoch) return
        return request('cart/update.js', payload).then(function () {
          if (!enabled || consent() !== true || startedEpoch !== epoch) return
          var current = valid(stored())
          if (current && current.signature === value.signature && current.paid === value.paid) {
            current.synced = signature
            save(current)
          }
          failures = 0
        })
      })
    })
  }

  function armCombinedExpiry() {
    var pilot = v2.state()
    if (!pilot) return
    var current = valid(stored())
    var deadline = v2.nextExpiry()
    if (current) deadline = Math.min(deadline, Date.parse(current.expires))
    if (!Number.isFinite(deadline)) return
    window.clearTimeout(expiryTimer)
    expiryTimer = window.setTimeout(function () {
      if (!enabled || consent() !== true) {
        v2.remove()
        return
      }
      v2.state()
      var value = valid(stored())
      if (!value && (memory || stored())) removeEvidence()
      if (v2.state()) armCombinedExpiry()
      else if (value) expiry(value)
      if (v2.pending() || cleanupPending) schedule(0)
    }, Math.min(Math.max(deadline - Date.now(), 1), 2147483647))
  }

  function sync() {
    // This branch preserves the original v1 code path for every non-enrolled visitor.
    if (!v2.relevant()) return syncV1()
    if (cleanupPending || v2.pending()) {
      if (failures > 2) return Promise.resolve()
      var clearV1 = cleanupPending, clearV2 = v2.pending(), empty = {}
      if (clearV1) ownedKeys.forEach(function (name) { empty['__gmc_' + name + '__'] = '' })
      if (clearV2) Object.assign(empty, v2.empty())
      checks += 1
      return request('cart/update.js', empty).then(function () {
        if (clearV1) pendingCleanup(false)
        if (clearV2) v2.clean()
        failures = 0
        if (enabled && consent() === true && (valid(stored()) || v2.state())) schedule(0)
      })
    }
    if (!enabled || consent() !== true || checks >= 40 || failures > 2) return Promise.resolve()
    if (Date.now() - lastCheck < 300) { schedule(310 - (Date.now() - lastCheck)); return Promise.resolve() }
    var value = valid(stored())
    if (!value && (memory || stored())) { removeEvidence(); armCombinedExpiry(); return Promise.resolve() }
    if (!value && !v2.state()) return Promise.resolve()
    var startedEpoch = epoch
    lastCheck = Date.now()
    checks += 1
    return request('cart.js').then(function (cart) {
      if (!enabled || consent() !== true || startedEpoch !== epoch) return
      var token = typeof cart.token === 'string' ? cart.token : ''
      if (!token || token.length > 2048) return
      return digest(token).then(function (binding) {
        if (!binding || !enabled || consent() !== true || startedEpoch !== epoch) return
        value = valid(stored())
        return v2.payload(binding).then(function (pilot) {
          if (!enabled || consent() !== true || startedEpoch !== epoch || v2.pending()) return
          var originalPayload = value ? attributes(value, binding) : null
          var originalSignature = originalPayload ? JSON.stringify(originalPayload) : ''
          if (!originalPayload && !pilot) return
          var combined = originalPayload || {}
          if (pilot) Object.assign(combined, pilot.attributes)
          return (pilot ? digest(JSON.stringify(pilot.attributes)) : Promise.resolve('')).then(function (pilotSignature) {
            if (!enabled || consent() !== true || startedEpoch !== epoch || v2.pending() || pilot && (!pilotSignature || !v2.matches(pilot.fingerprint))) return
            if ((!value || value.synced === originalSignature) && (!pilot || pilot.synced === pilotSignature)) return
            return request('cart/update.js', combined).then(function () {
              if (!enabled || consent() !== true || startedEpoch !== epoch) return
              var current = valid(stored())
              if (value && current && current.signature === value.signature && current.paid === value.paid) {
                current.synced = originalSignature
                save(current)
              }
              if (pilot) v2.synced(pilot.fingerprint, pilotSignature)
              failures = 0
              armCombinedExpiry()
            })
          })
        })
      })
    })
  }

  function schedule(delay) {
    window.clearTimeout(timer)
    timer = window.setTimeout(function () { enqueue(sync) }, typeof delay === 'number' ? delay : 350)
  }

  function paidEntry(params) {
    return ['gclid', 'gbraid', 'wbraid'].some(function (key) { return Boolean(params.get(key)) }) || /^(cpc|ppc|cpm|paid|paidsearch|paid_search|paid-social|paid_social|display)$/.test((params.get('utm_medium') || '').toLowerCase())
  }

  function captureV1() {
    if (!enabled || consent() !== true) return Promise.resolve()
    var currentEpoch = epoch
    var params = new URLSearchParams(window.location.search)
    var current = valid(stored())
    if (!current && (memory || stored())) removeEvidence()
    var campaign = (params.get('utm_campaign') || '').toLowerCase()
    var knownCampaign = /^(sag_organic|merchant_free_listings|gmc_free_listings|shopping free listings)$/.test(campaign)
    var manual = (params.get('utm_source') || '').toLowerCase() === 'google' && knownCampaign
    var rawClick = params.get('srsltid') || ''
    var native = /^[A-Za-z0-9_-]{8,512}$/.test(rawClick)
    var isPaid = paidEntry(params)
    if (!native && !manual) {
      if (current && isPaid && current.paid !== '1') {
        current.paid = '1'
        current.synced = ''
        save(current)
      }
      if (current) { expiry(current); schedule(0) }
      return Promise.resolve()
    }
    var path = window.location.pathname
    if (path.length > 200 || /[?#\\\s<>@]/.test(path) || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:(?:products|collections|pages)\/[A-Za-z0-9_\/-]+\/?)?$/i.test(path)) path = ''
    var variant = params.get('variant') || ''
    if (!/^\d{1,24}$/.test(variant)) variant = ''
    return Promise.all([native ? digest(rawClick) : Promise.resolve(''), digest(JSON.stringify(native ? ['native_srsltid', rawClick] : ['manual_feed_utm', campaign, path, variant]))]).then(function (hashes) {
      if (!enabled || consent() !== true || currentEpoch !== epoch || !hashes[1] || (native && !hashes[0])) return
      current = valid(stored())
      var nowMs = Date.now()
      var now = new Date(nowMs).toISOString()
      var same = current && current.signature === hashes[1]
      if (same) {
        if (isPaid) { current.paid = '1'; current.synced = '' }
      } else {
        current = {
          version: '1', type: native ? 'native_srsltid' : 'manual_feed_utm', click: hashes[0],
          campaign: knownCampaign ? campaign : '', path: path, variant: variant,
          first: current ? current.first : now, last: now,
          expires: current ? current.expires : new Date(nowMs + lifetime).toISOString(),
          paid: isPaid || (current && current.paid === '1') ? '1' : '0', signature: hashes[1], synced: ''
        }
      }
      if (!valid(current)) return
      save(current)
      expiry(current)
      schedule(0)
    }).catch(function () {})
  }

  function capture() {
    return captureV1().then(function () { return v2.capture() }).then(function () {
      if (enabled && consent() === true && v2.state()) armCombinedExpiry()
    })
  }

  function refresh() {
    var allowed = consent()
    if (allowed === null) {
      if (!featureRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        featureRequested = true
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { refresh() }) } catch (error) {}
      }
      return
    }
    permissionReady = true
    if (allowed !== enabled) { enabled = allowed; epoch += 1; captureStarted = false; failures = 0 }
    if (!enabled) { removeEvidence(); v2.remove(); return }
    if (!captureStarted) {
      captureStarted = true
      enqueue(capture)
    } else schedule()
  }

  function wake() {
    v2.activity(true)
    refresh()
  }

  try { cleanupPending = window.localStorage.getItem(cleanupKey) === '1' } catch (error) {}
  document.addEventListener('visitorConsentCollected', refresh)
  window.addEventListener('pageshow', wake)
  window.addEventListener('focus', wake)
  window.addEventListener('online', function () {
    failures = 0
    refresh()
    if (cleanupPending) schedule(0)
  })
  window.addEventListener('storage', function (event) {
    v2.onStorage(event)
    if (event.key === storageKey || event.key === cleanupKey) {
      try { cleanupPending = window.localStorage.getItem(cleanupKey) === '1' } catch (error) {}
      if (cleanupPending || (enabled && consent() === true)) schedule()
    }
  })
  ;['cart:updated', 'cart:change', 'cart:refresh', 'product:added', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, function () { if (enabled) schedule() })
  })
  document.addEventListener('pointerdown', function (event) {
    v2.activity(false)
    if (enabled && event.target && event.target.closest && event.target.closest('a[href*="/checkout"], [name="checkout"], .shopify-payment-button, shopify-accelerated-checkout')) schedule(0)
  }, { capture: true, passive: true })
  document.addEventListener('submit', function (event) {
    v2.activity(true)
    if (!enabled || !event.target || !event.target.action) return
    try {
      var destination = new URL(event.target.action, window.location.href)
      if (destination.origin === window.location.origin && /\/cart(?:\/add)?\/?$|\/checkout(?:\/|$)/.test(destination.pathname)) schedule(0)
    } catch (error) {}
  }, { capture: true, passive: true })
  document.addEventListener('keydown', function () { v2.activity(false) }, { capture: true, passive: true })
  window.addEventListener('pagehide', function () { v2.activity(true) })
  if (typeof PerformanceObserver === 'function') {
    try {
      var observer = new PerformanceObserver(function (entries) {
        if (!enabled) return
        if (entries.getEntries().some(function (entry) {
          try {
            var url = new URL(entry.name)
            return url.origin === window.location.origin && /\/cart\/(?:add|change|clear)(?:\.js)?\/?$/.test(url.pathname)
          } catch (error) { return false }
        })) schedule()
      })
      observer.observe({ type: 'resource', buffered: false })
    } catch (error) {}
  }
  if (cleanupPending || v2.pending()) schedule(0)
  refresh()
  var attempts = 0
  function waitForPrivacy() {
    attempts += 1
    refresh()
    if (!permissionReady && attempts < 10) refreshTimer = window.setTimeout(waitForPrivacy, 500)
  }
  if (!permissionReady) refreshTimer = window.setTimeout(waitForPrivacy, 500)
})()
